<template>
    <div class="dam-profile-card" @click="SET_SHOW_MOBILE_GRAPHIC">
        <div class="card-detail-text mt-2">
            <h5 class="card-detail-heading">{{$t('dam-profile.dam-graphic')}}</h5>
        </div>
        <div class="d-flex justify-content-center align-items-center">
            <img class="dam-img pt-4" :src="img.damProfileImage"/>
        </div>
    </div>
</template>

<script>
    // vuex
    import {mapActions} from "vuex";
    import {SET_SHOW_MOBILE_GRAPHIC} from "../../store/actions/profile";
    // assets
    import damProfileImage from '../../assets/img/dam-profile-image.svg';

    export default {
        name: "ProfileDamGraphicCardLink",
        data() {
            return {
                img: {
                    damProfileImage
                }
            }
        },
        methods: {
            ...mapActions([SET_SHOW_MOBILE_GRAPHIC])
        }
    }
</script>

<style lang="scss" scoped>
    @import "src/assets/scss/_variables";
    @import "src/assets/scss/_cardDetail";

    .dam-img {
        width: 100%;
        max-width: 90px;
    }
</style>